import {
    SELECT_AIR_QUALITY_HEALTH_ADVICE,
    SELECT_AIR_QUALITY_POLLUTANT,
    CLOSE_AIR_QUALITY_POLLUTANT_HEALTH_ADVICE_POPUP,
    SelectHealthAdviceActionType,
    SelectPollutantActionType,
    CloseAqiPollutantHealthAdvicePopupActionType
} from '../actions/aqiTopTriggerHealthAdviceDetailsModalActions';

import { AqiTopTriggerHealthAdviceDetailsModalState } from '../../components/common/interfaces/types';

export type AqiDetailModalActionType = CloseAqiPollutantHealthAdvicePopupActionType | SelectHealthAdviceActionType | SelectPollutantActionType;

const initialState: AqiTopTriggerHealthAdviceDetailsModalState = {
    isTopTriggerHealthAdviceDetailPopupOpen: false
};

export function aqiTopTriggerHealthAdviceDetailModal(state = initialState, action: AqiDetailModalActionType): AqiTopTriggerHealthAdviceDetailsModalState
{
    switch (action.type)
    {
        case CLOSE_AIR_QUALITY_POLLUTANT_HEALTH_ADVICE_POPUP: 
        {
            return {
                ...state,
                selectedAqiHealthAdvice: undefined,
                selectedAqiPollutant: undefined,
                isTopTriggerHealthAdviceDetailPopupOpen: false
            };
        }
        case SELECT_AIR_QUALITY_HEALTH_ADVICE: 
        {
            return {
                ...state,
                selectedAqiHealthAdvice: action.payload?.healthAdviceType,
                isTopTriggerHealthAdviceDetailPopupOpen: action.payload?.showPopup
            };
        }
        case SELECT_AIR_QUALITY_POLLUTANT: 
        {
            return {
                ...state,
                selectedAqiPollutant: action.payload?.pollutantType,
                isTopTriggerHealthAdviceDetailPopupOpen: action.payload?.showPopup
            };
        }
        default:
        {
            return {
                ...state
            };
        }
            
    }
}
